import React from 'react'
import './AreaOfOperations.css'

const AreaOfOperations = ({ transporter_data }) => {
    const operations = transporter_data?.zone ?? ['Details not available']

    return (
        <div className="aopcard">
            <div className="aopcontainer">
                <span className="data_header">Area of Operations</span>
                <ol className="aopol">
                    {operations.map((item, i) => (
                        <li key={i} className="aoplist">
                            {item.charAt(0).toUpperCase() + item.substring(1).toLowerCase()}
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    )
}

export default AreaOfOperations
